import { render, staticRenderFns } from "./employer-icons.vue?vue&type=template&id=4d5672a3"
import script from "./employer-icons.vue?vue&type=script&lang=js"
export * from "./employer-icons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports